<template>
  <div :style="{ width: displayInline ? 'fit-content' : '100%', display: displayInline ? 'inline' : 'block' }">
    <div class="checkbox-input-input-container">
      <Field
        v-slot="{ field }"
        v-model="mutatedValue"
        :label="label"
        :name="name"
        :rules="validation"
        tag="div"
      >
        <input
          :id="name"
          :ref="name"
          type="checkbox"
          :data-vv-name="name"
          v-bind="field"
          :disabled="isReadOnly"
          @change="onChange"
        >
        <input
          v-model="mutatedValueInput"
          type="text"
          class="bordered-bottom"
          :data-vv-name="name"
          :placeholder="placeholder"
          :isReadOnly="isReadOnly"
          :disabled="inputDisabled"
          @input="onInput"
        >
        <ErrorMessage
          class="error-msg"
          :name="name"
        />
      </Field>
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * label: label displayed (string),
 * name: input name (string)
 * value: if the checkbox is checked or not (Boolean)
 */
export default {
  name: 'CheckboxInput',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    defaultValue: [Boolean, Array, Object],
    name: String,
    displayInline: Boolean,
    onlyOneSelected: {
      type: Boolean,
      default: false
    },
    checkBoxUniq: {
      type: Object,
      default: null
    },
    mainName: {
      type: String,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addData', 'onlyOneSelectedName'],
  data() {
    return {
      mutatedValue: this.defaultValue ? this.defaultValue.value : false,
      mutatedValueInput: this.defaultValue.value ? this.defaultValue.text : '',
      tempValueInput: this.defaultValue.value ? this.defaultValue.text : '',
      inputDisabled: this.defaultValue.value && !this.isReadOnly ? false : true
    }
  },
  computed: {
    mutatedResult() {
      return { value: this.mutatedValue, text: this.mutatedValue ? this.mutatedValueInput : '' }
    },
    fieldMultipleDiff() {
      return this.checkBoxUniq[this.mainName] !== this.name
    }
  },
  watch: {
    fieldMultipleDiff() {
      if (this.fieldMultipleDiff) {
        this.mutatedValue = false
      }
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedResult, name: this.name })
      : this.$emit('addData', { value: false, name: this.name })
  },
  methods: {
    onChange(e) {
      this.$emit('addData', { value: this.mutatedResult, name: this.name })
      if (!this.inputDisabled) {
        this.mutatedValueInput = this.tempValueInput
        this.onInput()
      } else {
        this.tempValueInput = this.mutatedValueInput
        this.mutatedValueInput = ''
      }
      if (this.onlyOneSelected) {
        if (e.target.checked) {
          this.$emit('onlyOneSelectedName', { mainName: this.mainName, name: this.name })
        } else {
          this.$emit('onlyOneSelectedName', { mainName: this.mainName, name: null })
        }
      }
    },
    onInput() {
      this.$emit('addData', { value: this.mutatedResult, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-input-input-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    input[type='checkbox'] {
      border-radius: 0;
      position: relative;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin-right: 8px;
      border: 1px black solid;
      min-height: 1rem;
      min-width: 1.2rem;
      background-color: transparent;
      transition: 0.3s;

      @media only screen and (width >= 768px) {
        min-height: 1.5rem;
        min-width: 1.5rem;
      }

      /* Desktops and laptops */
      @media only screen and (width >= 1024px) {
        min-height: 1.5rem;
        min-width: 1.5rem;
      }

      /* Large screens */
      @media only screen and (width >= 1824px) {
        min-height: 1.75rem;
        min-width: 1.75rem;
      }
    }

    input[type='checkbox']:checked,
    input[type='checkbox']:checked:disabled {
      background-color: black;
      transition: 0.3s;
    }

    input[type='checkbox']:disabled {
      background-color: rgb(189 189 189);
    }

    input[type='text'] {
      width: 7rem;
    }
  }
</style>
